var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"carousel",staticClass:"carousel"},_vm._l((_vm.slotCount),function(i){return _c('div',{key:i,staticClass:"carousel-item",class:_vm.carouselItemClass(i - 1)},[(_vm.isRendered(i - 1))?_c('div',{staticClass:"mask"},[_c('div',{staticClass:"slot slot-left"},[_vm._t(("left-" + i))],2),_vm._v(" "),_c('div',{staticClass:"slot slot-right"},[_vm._t(("right-" + i))],2)]):_vm._e()])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11684113","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Carousel.vue
// module id = 64
// module chunks = 0